import { render } from "./FinancialDashboard.vue?vue&type=template&id=e8c1d9c6&scoped=true"
import script from "./FinancialDashboard.vue?vue&type=script&lang=js"
export * from "./FinancialDashboard.vue?vue&type=script&lang=js"

import "./FinancialDashboard.vue?vue&type=style&index=0&id=e8c1d9c6&scoped=true&lang=css"

import exportComponent from "/var/www/potabilis/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8c1d9c6"]])

export default __exports__